<template>
	<inertia-head title="Monitoring" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Members Survey</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Members survey report
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded mb-4">
			<div class="block-content">
				<div class="mb-4">
					<label class="form-label">Choose subscription</label>
					<div class="row">
						<div class="col-md-2">
							<div class="form-check form-block">
								<input
									v-model="tabsub"
									class="form-check-input"
									type="radio"
									id="ALL"
									name="monitoring"
									value="ALL"
									checked=""
								/>
								<label class="form-check-label bg-info text-white fw-bold" for="ALL">ALL</label>
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-check form-block">
								<input
									v-model="tabsub"
									class="form-check-input"
									type="radio"
									id="SILVER"
									name="monitoring"
									value="Silver"
								/>
								<label class="form-check-label bg-secondary text-white fw-bold" for="SILVER">SILVER</label>
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-check form-block">
								<input
									v-model="tabsub"
									class="form-check-input"
									type="radio"
									id="GOLD"
									name="monitoring"
									value="Gold"
								/>
								<label class="form-check-label bg-primary text-white fw-bold" for="GOLD">GOLD</label>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-check form-block">
								<input
									v-model="tabsub"
									class="form-check-input"
									type="radio"
									id="DIAMOND"
									name="monitoring"
									value="Diamond"
								/>
								<label class="form-check-label bg-warning text-white fw-bold" for="DIAMOND">DIAMOND</label>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-check form-block">
								<input
									v-model="tabsub"
									class="form-check-input"
									type="radio"
									id="PLATINUM"
									name="monitoring"
									value="Platinum"
								/>
								<label class="form-check-label bg-success text-white fw-bold" for="PLATINUM">PLATINUM</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Component -->
		<div class="row">
			<div
				v-for="(data,sIndex) in surveys"
				:key="data.survey_item_uuid"
				:class="
					`col-md-6 col-xl-` +
					(surveys.length % 4 === 0
						? '3'
						: surveys.length % 3 === 0
						? '4'
						: surveys.length === 2
						? '6'
						: '4')
				"
			>
				<div
					class="block block-rounded block-link-shadow"
					href="javascript:void(0)"
				>
					<div class="block-content block-content-full text-end ribbon ribbon-left ribbon-info">
						<div class="ribbon-box">{{sIndex+1}}</div>
						<div class="fs-2 fw-bold">{{ parseInt(data.silver)+parseInt(data.gold)+parseInt(data.diamond)+parseInt(data.platinum) || 0 }} <a @click="fetchMembers(data.survey_item_uuid,(sIndex+1),0)" class="block-link-shadow text-info" href="javascript:void(0)"><i class="fa fa-search"></i></a></div>
						<div class="text-muted">TOTAL ENTRIES</div>
						<div class="fs-sm fw-semibold text-muted text-start" style="height:45px;">
							{{ data.survey_question }}
						</div>
					</div>
					<h7 class="block-content block-content-full pb-0 fs-sm fw-semibold text-muted">RATINGS: {{data.average}}</h7>
					<div class="block-content block-content-full">
						<div class="row">
							<div class="col-sm-8">
								<span class="fa fa-fw fa-star text-primary"></span>
							</div>
							<div class="col-sm-4 text-end"><h6 class="mb-0 fw-semibold">{{ data.answer_1 }} <a @click="fetchMembers(data.survey_item_uuid,(sIndex+1),1)" class="block-link-shadow text-info" href="javascript:void(0)"><i class="fa fa-search"></i></a></h6></div>
						</div>
						<div class="row">
							<div class="col-sm-8">
								<span class="fa fa-fw fa-star text-primary"></span>
								<span class="fa fa-fw fa-star text-primary"></span>
							</div>
							<div class="col-sm-4 text-end"><h6 class="mb-0 fw-semibold">{{ data.answer_2 }} <a @click="fetchMembers(data.survey_item_uuid,(sIndex+1),2)" class="block-link-shadow text-info" href="javascript:void(0)"><i class="fa fa-search"></i></a></h6></div>
						</div>
						<div class="row">
							<div class="col-sm-8">
								<span class="fa fa-fw fa-star text-primary"></span>
								<span class="fa fa-fw fa-star text-primary"></span>
								<span class="fa fa-fw fa-star text-primary"></span>
							</div>
							<div class="col-sm-4 text-end"><h6 class="mb-0 fw-semibold">{{ data.answer_3 }} <a @click="fetchMembers(data.survey_item_uuid,(sIndex+1),3)" class="block-link-shadow text-info" href="javascript:void(0)"><i class="fa fa-search"></i></a></h6></div>
						</div>
						<div class="row">
							<div class="col-sm-8">
								<span class="fa fa-fw fa-star text-primary"></span>
								<span class="fa fa-fw fa-star text-primary"></span>
								<span class="fa fa-fw fa-star text-primary"></span>
								<span class="fa fa-fw fa-star text-primary"></span>
							</div>
							<div class="col-sm-4 text-end"><h6 class="mb-0 fw-semibold">{{ data.answer_4 }} <a @click="fetchMembers(data.survey_item_uuid,(sIndex+1),4)" class="block-link-shadow text-info" href="javascript:void(0)"><i class="fa fa-search"></i></a></h6></div>
						</div>
						<div class="row">
							<div class="col-sm-8">
								<span class="fa fa-fw fa-star text-primary"></span>
								<span class="fa fa-fw fa-star text-primary"></span>
								<span class="fa fa-fw fa-star text-primary"></span>
								<span class="fa fa-fw fa-star text-primary"></span>
								<span class="fa fa-fw fa-star text-primary"></span>
							</div>
							<div class="col-sm-4 text-end"><h6 class="mb-0 fw-semibold">{{ data.answer_5 }} <a @click="fetchMembers(data.survey_item_uuid,(sIndex+1),5)" class="block-link-shadow text-info" href="javascript:void(0)"><i class="fa fa-search"></i></a></h6></div>
						</div>
					</div>
				</div>
			</div>
		</div>


		<modal ref="surveyCommentModal" size="modal-md">
			<template #title>
				SURVEY COMMENT
			</template>
			<template #body>
				<div class="mb-4 text-center h4">
					{{member_survey_info.fname}} {{member_survey_info.lname}}
				</div>
				
				<div class="mb-4">
					<label>Comment</label>
					<textarea v-model="member_survey_info.survey_comment" class="form-control" readonly rows="5"></textarea>
				</div>
			</template>
			<template #footer>
				<button type="button" class="btn btn-sm btn-alt-danger" @click="surveyCommentModal.toggleModal()"><i class="fa fa-times"></i> Close</button>
			</template>
		</modal>


		<div class="block block-rounded">
			<div class="block-header block-header-default">
				<div class="block-title">MEMBERS SURVEY [{{membership || 'ALL'}}] <span v-if="q_no>0">[ QUESTION#: {{q_no}} ]</span> <span v-if="star_no>0">[ {{star_no}} STAR ]</span> </div>
			</div>
			<div class="block-content">
				<div class="table-responsive">
					<table id="members_table" class="table table-hover">
						<thead>
							<tr>
								<th>Member Name</th>
								<th>Email</th>
								<th>Contact#</th>
								<th>Expiry</th>
								<th>Rating</th>
								<th>Comment</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(member,mIndex) in membersSurvey.data">
								<td>{{member.fname}} {{member.lname}}<br/><sub>{{member.membership}}</sub></td>
								<td>{{member.username}}</td>
								<td>{{member.mobile}}</td>
								<td>{{member.expiry}}</td>
								<td nowrap="">{{member.survey_rate}}</td>
								<td class="text-end"><button type="button" @click="viewComment(mIndex)" class="btn btn-sm btn-info" :disabled="member.survey_comment==null || member.survey_comment==''"><i class="fa fa-search"></i></button></td>
							</tr>
							<tr v-if="membersSurvey.length<=0">
								<td colspan="6" class="text-center my-4 fw-bold text-danger">No Record Found...</td>
							</tr>
						</tbody>
					</table>
				</div>
				<pagination v-if="membersSurvey.data.length > 0" :collections="membersSurvey" />
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted,ref,watch } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import AuthLayout from '../../../Layouts/AuthLayout'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	layout: AuthLayout,
	props: {
		surveys 		: Object,
		year 			: String,
		membership 		: String,
		item_uuid 		: String,
		q_no 			: Number,
		star_no 		: Number,
		membersSurvey 	: Object,
	},

	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const tabsub = ref(props.tab);

		const surveyCommentModal = ref();

		const member_survey_info = useForm({
			fname: null,
			lname: null,
			survey_comment: null
		});

		const fetchMembers = (item_uuid,q_no,star_no)=>{

			Inertia.get(
					route('admin.reports.members-survey'),
					{
						membership 	: tabsub.value,
						item_uuid 	: item_uuid,
						q_no 		: q_no,
						star_no 	: star_no,
					},
					{
						preserveState: true,
						preserveScroll: true,
						only:['membersSurvey,item_uuid,q_no,star_no'],
						onSuccess:()=>{
							window.scrollTo(0,$("#members_table")[0].offsetTop);
						}
					},
				)

		}

		const viewComment = (_index)=>{
			member_survey_info.fname 			= props.membersSurvey.data[_index].fname;
			member_survey_info.lname 			= props.membersSurvey.data[_index].lname;
			member_survey_info.survey_comment 	= props.membersSurvey.data[_index].survey_comment;

			surveyCommentModal.value.toggleModal();
		}

		watch(()=>tabsub.value,
			(tab) => {
				Inertia.get(
					route('admin.reports.members-survey'),
					{
						membership: tab,
					},
					{
						preserveState: true,
						preserveScroll: true,
						only:['surveys,membersSurvey,year,membership,item_uuid,q_no,star_no'],
						onSuccess:()=>{
							window.scrollTo(0,$("#members_table")[0].offsetTop);
						}
					},
				)
			}
		)

		return {
			tabsub,
			fetchMembers,
			surveyCommentModal,
			member_survey_info,
			viewComment,
		}
	},
}
</script>
